export const THIRD_PARTY_AUTH_PATH = '/api/v1/third-party-auth';
export const MY_THIRD_PARTY_AUTH_PATH = `${THIRD_PARTY_AUTH_PATH}/me`;
export const THIRD_PARTY_SOCIAL_AUTH_PATH =
  '/api/v1/third-party-auth/social-auth';
export const MY_SOCIAL_AUTH_URL = `${THIRD_PARTY_SOCIAL_AUTH_PATH}/me`;

export const GOOGLE_LOGIN_URL = `${THIRD_PARTY_SOCIAL_AUTH_PATH}/google/login`;

export const THIRD_PARTY_LINKEDIN_PATH = `${THIRD_PARTY_AUTH_PATH}/linkedin`;
export const MY_THIRD_PARTY_LINKEDIN_PATH = `${THIRD_PARTY_LINKEDIN_PATH}/me`;
export const THIRD_PARTY_FACEBOOK_PATH = `${THIRD_PARTY_AUTH_PATH}/facebook`;
export const MY_THIRD_PARTY_FACEBOOK_PATH = `${THIRD_PARTY_FACEBOOK_PATH}/me`;
export const THIRD_PARTY_YOUTUBE_PATH = `${THIRD_PARTY_AUTH_PATH}/youtube`;
export const MY_THIRD_PARTY_YOUTUBE_PATH = `${THIRD_PARTY_YOUTUBE_PATH}/me`;
export const THIRD_PARTY_TIKTOK_PATH = `${THIRD_PARTY_AUTH_PATH}/tiktok`;
export const MY_THIRD_PARTY_TIKTOK_PATH = `${THIRD_PARTY_TIKTOK_PATH}/me`;
export const THIRD_PARTY_CANVA_PATH = `${THIRD_PARTY_AUTH_PATH}/canva`;
export const MY_THIRD_PARTY_CANVA_PATH = `${THIRD_PARTY_CANVA_PATH}/me`;
